import React, { Fragment, } from 'react'
import './style.css'
export default function News(props) {
    const { data } = props;
    return (
        <div className='GuideCarousel_News'>
            <div className='GuideCarousel_NewsLeft'>
                <img className='GuideCarousel_NewsLeftImg' src={data.image}/>
            </div>
            <div className='GuideCarousel_NewsRight'>
                <div className='GuideCarousel_NewsRightTitle'>{data.title}</div>
                <div className='GuideCarousel_NewsRightTitleBottom'/>
                <div className='GuideCarousel_NewsRightContent'>{data.content}</div>
                <div className='GuideCarousel_NewsRightTime'>{data.time}</div>
            </div>
        </div>
    )
}